import React, {ReactNode, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadMarketPopularBlockData from '../../../Models/Content/AbroadMarketPopularBlockData';
import AbroadMarketPopularMain from './AbroadMarketPopularMain';

export default class AbroadMarketPopularBlock extends EpiComponent<AbroadMarketPopularBlockData> {
  public render(): null | ReactNode {
    return <AbroadMarketPopularMain context={this.getContext()} props={this.props.data} />;
  }
}
